import * as React from "react";
import { Button } from "../button/button.mjs";
import { TableCell } from "../table/table-cell/table-cell.mjs";
import { Term } from "./term.mjs";
import { cellBEM } from "./utils.mjs";
const NameCell = (props) => {
  const { item, isMobile, deviceLabel, renderButton = true, width = 2, isDisabled = false } = props;
  const content = renderButton ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", null, "".concat(item.manufacturer, " "), /* @__PURE__ */ React.createElement("span", { className: "sr-only" }, item.name)), /* @__PURE__ */ React.createElement(Button, { ...item.button, text: item.name, link: true, disabled: isDisabled })) : "".concat(item.manufacturer, " ").concat(item.name);
  if (isMobile) {
    return /* @__PURE__ */ React.createElement(TableCell, { className: cellBEM(), width }, /* @__PURE__ */ React.createElement(Term, { label: deviceLabel }, content));
  }
  return /* @__PURE__ */ React.createElement(TableCell, { className: cellBEM(), width, valign: "top", type: "th", scope: "col" }, content);
};
export {
  NameCell
};
